export const IMAGE_MIN_WIDTH = 350;

// ─── Worker pool sizing ──────────────────────────────────
/** 워커 1개당 peak 메모리 추정치 (MB). 24MP 이미지(6000×4000) 기준 ~170MB */
export const WORKER_PEAK_MEMORY_MB = 170;
/** 이미지 압축에 할당할 디바이스 메모리 비율 (나머지는 메인 스레드·탭 등이 사용) */
export const MEMORY_BUDGET_RATIO = 0.5;
/** 워커 풀 최소·최대 크기 */
export const MIN_POOL_SIZE = 1;
export const MAX_POOL_SIZE = 6;

// ─── 미리보기 썸네일 ──────────────────────────────────────
/** 썸네일 짧은 변 목표(px). 그리드가 102px 정사각형이라 DPR 2 기준으로 잡는다. */
export const THUMBNAIL_SHORT_SIDE = 204;
/** 썸네일 인코딩 품질. 102px 로 표시되므로 낮게 잡아도 눈에 띄지 않는다. */
export const THUMBNAIL_QUALITY = 0.8;
